"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StickyNav;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _functions = require("../anchor-link-nav/functions");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _navLink = _interopRequireDefault(require("./nav-link"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */

const StickyNavContainer = /*#__PURE__*/(0, _react2.styled)("nav")({
  name: "StickyNavContainer",
  class: "pl-s16uby3q"
});
const NavBar = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavBar",
  class: "pl-n1363w94"
});
const ListMenu = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "ListMenu",
  class: "pl-l97deue"
});
const NavItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "NavItem",
  class: "pl-n1yakdfz"
});
const GradientContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GradientContainer",
  class: "pl-grs819j"
});
const Gradient = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Gradient",
  class: "pl-gxhvx39"
});
function StickyNav({
  _name,
  items = [],
  cta
}) {
  const ids = items?.filter(item => item.anchor).map(item => item.anchor);
  const navHeight = 72;
  const activeSection = (0, _functions.useScrollDetect)(ids, navHeight);
  const stickyNavRef = (0, _react.useRef)(null);
  const activeRef = (0, _react.useRef)(null);
  const [isScrolling, setIsScrolling] = (0, _react.useState)(false);
  _patternLibraryUtils.tracking.useTracking(stickyNavRef);
  const trackingProps = _patternLibraryUtils.tracking.props(_name);
  (0, _react.useEffect)(() => {
    const rect = stickyNavRef.current?.getBoundingClientRect();
    const isSticky = rect?.top === 0;
    if (!isScrolling && isSticky) {
      activeRef?.current?.scrollIntoView({
        inline: 'center'
      });
    }
  }, [activeSection]);
  (0, _react.useEffect)(() => {
    if (stickyNavRef?.current?.parentElement?.classList.contains('swp-react')) {
      // SWP wraps each component inside another DOM element.
      // This Parent Element needs to have the sticky attributes
      const stickyElement = stickyNavRef?.current?.closest('*:not(*:last-child)');
      if (stickyElement !== null) {
        stickyElement.style.position = 'sticky';
        stickyElement.style.zIndex = _patternLibraryUtils.knownZIndexes.secondaryNav;
        stickyElement.style.top = '0';
      }
    }
  });
  const handleClick = event => {
    event?.preventDefault();
    clearTimeout(isScrolling);
    setIsScrolling(setTimeout(() => {
      setIsScrolling(false);
    }, 1000));
    (0, _patternLibraryUtils.scrollToAnchor)(event.currentTarget, navHeight);
  };
  return /*#__PURE__*/_react.default.createElement(StickyNavContainer, (0, _extends2.default)({
    "data-cy": "sticky-nav",
    ref: stickyNavRef
  }, trackingProps), /*#__PURE__*/_react.default.createElement(NavBar, {
    "data-cy": "nav-bar"
  }, /*#__PURE__*/_react.default.createElement(ListMenu, {
    "data-cy": "list-menu"
  }, items?.map((item, i) => {
    const active = !item.href && activeSection === item.anchor;
    return /*#__PURE__*/_react.default.createElement(NavItem, {
      key: i,
      "data-cy": "nav-item",
      "data-active": active,
      ref: active ? activeRef : null
    }, /*#__PURE__*/_react.default.createElement(_navLink.default, (0, _extends2.default)({}, item, {
      onClick: item?.anchor ? handleClick : () => null
    })));
  })), /*#__PURE__*/_react.default.createElement(GradientContainer, null, /*#__PURE__*/_react.default.createElement(Gradient, null), cta && /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [{
      ...cta,
      size: 'small'
    }]
  }))));
}
StickyNav.propTypes = {
  _name: _propTypes.default.string,
  items: _propTypes.default.array,
  moreText: _propTypes.default.string,
  cta: _propTypes.default.shape({
    ..._merchButton.NSMerchButton.propTypes
  })
};